/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { SysqueGaugeTakeOffServiceModule } from './sysque-gauge-take-off-service.module';
export { SysqueGaugeTakeOffServiceComponent } from './sysque-gauge-take-off-service.component';
